module.exports = __webpack_public_path__ + "img/bq.1af2afbe.svg";